import {TotalsData} from "../../types";
import {formatTakeRate, formatTotal} from "../../../../../utils/generalFormat";
import {ValueCard} from "../../styles";

export const Totals: React.FC<{
  data: TotalsData,
  userType?: number | null,
  isAdmin: boolean }> = (
  {
    data,
    userType,
    isAdmin
  }) => {
  return (
    <>
      <ValueCard>
        <div>
          <p><b>Valor das Vendas:</b></p>
          <p>{formatTotal(data.totalValue)}</p>
        </div>

        <div>
          <p><b>Valor Líquido:</b></p>
          <p>{formatTotal(data.totalLiquidValue)}</p>
        </div>

        {(userType === 3 && isAdmin) && (
          <div>
            <p><b>Custo Total MDR:</b></p>
            <p>{formatTotal(data.totalMdrValue)}</p>
          </div>
        )}

        {(!isAdmin) && (
          <div>
            <p><b>Custo Total MDR Parceiro:</b></p>
            <p>{formatTotal(data.totalPartnerMdrValue)}</p>
          </div>
        )}

        {(userType === 3 && isAdmin) && (
          <div>
            <p><b>Custo Antecipação:</b></p>
            <p>{formatTotal(data.totalAnticipation)}</p>
          </div>
        )}

        {(!isAdmin) && (
          <div>
            <p><b>Custo Antecipação Parceiro:</b></p>
            <p>{formatTotal(data.totalPartnerAnticipation)}</p>
          </div>
        )}

        {(userType === 3 && isAdmin) && (
          <div>
            <p><b>Custo Total:</b></p>
            <p>{formatTotal(data.totalCost)}</p>
          </div>
        )}

        {(!isAdmin) && (
          <div>
            <p><b>Custo Total Parceiro:</b></p>
            <p>{formatTotal(data.totalPartnerCost)}</p>
          </div>
        )}

        {(userType === 3 && isAdmin) && (
          <div>
            <p><b>Recebido Acquirer:</b></p>
            <p>{formatTotal(data.totalAcquirer)}</p>
          </div>
        )}

        {(userType === 3 && isAdmin) && (
          <div>
            <p><b>Receita:</b></p>
            <p>{formatTotal(data.totalRevenue)}</p>
          </div>
        )}

        {(!isAdmin) && (
          <div>
            <p><b>Receita Parceiro:</b></p>
            <p>{formatTotal(data.totalPartnerRevenue)}</p>
          </div>
        )}

        {(userType === 3 && isAdmin) && (
          <div>
            <p><b>Take Rate:</b></p>
            <p>{formatTakeRate(data.takeRate)}</p>
          </div>
        )}

      </ValueCard>
    </>
  )
}
